import {
  ConveyanceAttachementDetails,
  EXCEL,
  Images,
  PDF,
} from "../../../../../utils/Constant";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { closeModal } from "../../../../../ReduxToolkit/Slice/UserProfileDetailsModalSlice";
import { Col, Row } from "reactstrap";
import { H5, LI, P, UL } from "../../../../../AbstractElements";
import { lazy } from "react";
import { ConveyanceAttachmentModalProps } from "../../../types";

const CommonModal = lazy(
  () => import("../../../../../Component/Ui-Kits/Modal/Common/CommonModal")
);

const IframeView = lazy(() => import("../../../../../CommonElements/Iframe"));

const ProductImageCard = lazy(
  () => import("../../../../../CommonElements/ProductImageCard")
);

const ConveyanceAttachmentCollectionModal = ({
  isOpen,
  attachmentCollection,
}: ConveyanceAttachmentModalProps) => {
  const dispatch = useAppDispatch();

  const handleDownload = (imageUrl: string, filename: string = "image.jpg") => {
    const link = document.createElement("a");
    link.href = imageUrl;
    link.target = "_blank";
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <CommonModal
      headerClassName="bg-primary"
      titleClassName="text-white"
      title={ConveyanceAttachementDetails}
      modalBodyClassName="ps-lg-4"
      centered
      toggle={() => dispatch(closeModal())}
      isOpen={isOpen}
      showFooter={false}
    >
      <div className="modal-toggle-wrapper">
        {attachmentCollection &&
          attachmentCollection?.img &&
          Array.isArray(attachmentCollection?.img) &&
          attachmentCollection?.img?.length > 0 && (
            <Row className="mb-5">
              <H5 className="text-underline mb-3">{Images}</H5>
              {attachmentCollection?.img?.map((d: string, index: number) => (
                <Col
                  xs="12"
                  md={attachmentCollection.img.length > 2 ? "4" : "6"}
                >
                  <ProductImageCard
                    imageSrc={d}
                    altImage="download"
                    handleDownload={handleDownload}
                    key={index}
                    isShowHover={true}
                  />
                </Col>
              ))}
            </Row>
          )}

        {attachmentCollection &&
          attachmentCollection?.pdf &&
          Array.isArray(attachmentCollection?.pdf) &&
          attachmentCollection?.pdf?.length > 0 &&
          attachmentCollection?.pdf?.map((file: string, index: number) => (
            <Row>
              <H5 className="text-underline mb-3">{PDF}</H5>
              <Col xs="12" key={index}>
                <div className="w-100 h-100">
                  <IframeView file={file} heightValue="500px" />
                </div>
              </Col>
            </Row>
          ))}

        {attachmentCollection &&
          attachmentCollection?.excel &&
          Array.isArray(attachmentCollection?.excel) &&
          attachmentCollection?.excel?.length > 0 && (
            <Row>
              <H5 className="text-underline mb-3">{EXCEL}</H5>
              <UL>
                {attachmentCollection?.excel?.map((file) => (
                  <LI>
                    <P className="w-100 pointer position-relative text-wrap d-block overflow-hidden m-0">
                      <a href={file} target="_blank" download>
                        {file}
                      </a>
                    </P>
                  </LI>
                ))}
              </UL>
            </Row>
          )}
      </div>
    </CommonModal>
  );
};

export default ConveyanceAttachmentCollectionModal;
